import { render } from "./Body.vue?vue&type=template&id=1f46f8a3&scoped=true"
const script = {}

import "./Body.vue?vue&type=style&index=0&id=1f46f8a3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f46f8a3"

export default script